<app-dialog-container
  [showCloseButton]="false"
  [showCancelButton]="false"
  [showConfirmButton]="false"
>
  <div class="rotation-dialog-content">
    <mat-icon class="rotation-icon">screen_rotation</mat-icon>
    <h2>{{ 'rotatePhoneToViewTables' | translate }}</h2>
    <p>{{ 'landscapeTableDescription' | translate }}</p>
    <app-ui-button color="primary" [text]="'gotIt' | translate" (click)="confirm()"></app-ui-button>
  </div>
</app-dialog-container>
